(() => {
  const sliders = new Map();

  const toBoolean = (value) => value === 'true';

  const mountSlider = (container) => {
    if (!window.Swiper || sliders.has(container)) return;

    const swiperElement = container.querySelector('.home-banner__swiper');
    if (!swiperElement) return;

    const slideCount = swiperElement.querySelectorAll('.swiper-slide').length;
    const effect = container.dataset.effect === 'fade' ? 'fade' : 'slide';
    const paginationEl = swiperElement.querySelector('.home-banner__pagination');

    const swiper = new Swiper(swiperElement, {
      effect,
      loop: slideCount > 1,
      speed: 800,
      autoplay:
        slideCount > 1 && toBoolean(container.dataset.autoplay)
          ? {
              delay: Number(container.dataset.interval) || 5000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
          }
        : false,
      fadeEffect: {
        crossFade: true,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      on: {
        init(swiperInstance) {
          swiperInstance.slides.forEach((slide) => slide.classList.remove('is-active'));
          if (swiperInstance.slides[swiperInstance.activeIndex]) {
            swiperInstance.slides[swiperInstance.activeIndex].classList.add('is-active');
          }
        },
        slideChange(swiperInstance) {
          swiperInstance.slides.forEach((slide) => slide.classList.remove('is-active'));
          if (swiperInstance.slides[swiperInstance.activeIndex]) {
            swiperInstance.slides[swiperInstance.activeIndex].classList.add('is-active');
          }
        },
      },
    });

    sliders.set(container, swiper);
  };

  const mountAll = (scope = document) => {
    scope.querySelectorAll('[data-home-banner]').forEach(mountSlider);
  };

  const destroySlider = (container) => {
    const swiper = sliders.get(container);
    if (!swiper) return;

    swiper.destroy(true, true);
    sliders.delete(container);
  };

  const init = () => {
    if (window.Swiper) {
      mountAll();
      return;
    }

    window.addEventListener('load', mountAll, { once: true });
  };

  document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', (event) => {
    mountAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-home-banner]').forEach(destroySlider);
  });
})();
